export default __webpack_public_path__ + "static/media/touchlessCheckin.4ec8c1a3.svg";